import React, { useEffect } from 'react';
import TabPageContainer from '~components/atoms/TabPageContainer';
import BranchesApprovalTable from './BranchesApprovalTable';
import BranchesApprovalPaginator from './BranchesApprovalPaginator';
import BranchApprovalTableSearchAndFilterBar from './BranchesApprovalSearchAndFilterBar';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import combinedActions from '~redux/combinedActions';
import ConfirmUpdateBranchesStatusModal from './ConfirmUpdateBranchesStatusModal';

const BranchesApproval = () => {
    const dispatch = useAppDispatch();

    const branchesListingIndex = useAppSelector(state => state.approval.pendingBranchesListing.index);

    useEffect(() => {
        dispatch(combinedActions.approvalGetPendingBranchesListingAttempt());
    }, [branchesListingIndex]);

    return (
        <TabPageContainer>
            <BranchApprovalTableSearchAndFilterBar />

            <BranchesApprovalTable />

            <BranchesApprovalPaginator />

            <ConfirmUpdateBranchesStatusModal />
        </TabPageContainer>
    );
};

export default BranchesApproval;
